import { Account, Audit } from '../../auth';
import { IssueMessageType } from '../../graphql';
import { Media } from '../../media';
import { WorkspaceRoutine } from '../../routine';
import { AssetRoutine } from '../../routine/domain/assetRoutine';
import { I18n } from '../../I18n';
import { Issue } from './issue';
import { EmojiType } from 'rn-emoji-keyboard/lib/typescript/types';

export interface Message extends Audit {
  id: string;
  type: IssueMessageType;
  issue: Issue;
  text: string;
  reminderData?: Reminder;
  media?: Media[];
  assetRoutine?: AssetRoutine;
  promptRoutine: WorkspaceRoutine;
  linkedIssue?: Issue;
  i18n?: I18n;
  userMentions: Account[];
  reactions?: Reaction[];
  actionData?: Record<string, any>;
}

export type Reminder = {
  reminderId: string;
  reminderType: 'date' | 'interval';
  reminderDate: string;
  intervalDays: string;
  startDate: string;
};

export interface Reaction {
  id: string;
  createdAt: string;
  createdBy: string;
  reactionType: EmojiType['emoji'];
}
